import { render, staticRenderFns } from "./Contactform.vue?vue&type=template&id=1f207837&scoped=true&"
import script from "./Contactform.vue?vue&type=script&lang=js&"
export * from "./Contactform.vue?vue&type=script&lang=js&"
import style0 from "./Contactform.vue?vue&type=style&index=0&id=1f207837&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f207837",
  null
  
)

export default component.exports